/* eslint-disable jsx-a11y/anchor-has-content */
import {Link, useParams, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import RightSideBar from '../../Components/RightSideBar';
import React, { useEffect, useState } from 'react';
import useAuth from '../../Hooks/useAuth';
import { jwtDecode } from 'jwt-decode';

//Editor
import EditorToolbar, { modules, formats } from "../../Components/EditorToolbar";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../css/TextEditor.css";
import ArticlePageBanner from './ArticlePageBanner';

const VIEW_ARTICLE_URL = '/articles/view/';
const DELETE_ARTICLE_URL = '/articles/delete/';
const UPLOAD_FILE_URL = '/singleUpload';
const EDIT_ARTICLE_URL = '/articles/edit/';



function Article({img}) {
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const authDecode = auth?.accessToken ? jwtDecode(auth.accessToken) : undefined;
    const [articlePost, setArticlePost] = useState({});  
    const [title, setTitle] = useState('');
    const [detail, setDetail] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [file, setFile] = useState(null);
    const navigate = useNavigate();
    let {id} = useParams();
  
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        axiosPrivate.get(VIEW_ARTICLE_URL + id).then((response)=>{
            if(isMounted){
                setArticlePost(response.data.oneArticle);  
                setTitle(response.data.oneArticle.title);
                setDetail(response.data.oneArticle.detail);         
            }
        }).catch((error) => {
            //Handle Errors Coming out of this
        });
        return () => { isMounted = false; controller.abort();  }
        // eslint-disable-next-line
    }, [id]);

    const deletePost = async(id) => {
        try {
            axiosPrivate.delete(DELETE_ARTICLE_URL + id).then(()=>{
                alert('Blog Post Deleted');
                navigate('/blog');
            });               
        } catch (error) {    }
    };

    const onDetail = (value) => {
        setDetail(value);
    } 

    const updatePost = async(e) => {
        e.preventDefault();
        const updatedStory = {title, detail, userId: authDecode.user.id, id: articlePost.id};

        if(file){
            const formData = new FormData();
            const filename = Date.now() + file.name;
            
            formData.append("name", filename);
            formData.append("file", file);
            updatedStory.picture = filename;
      
            try{
              await axiosPrivate.post(UPLOAD_FILE_URL, formData);
            }catch(err){
              console.log(err);
            }
        }
        
        try {
            axiosPrivate.put(EDIT_ARTICLE_URL + articlePost.id, updatedStory).then(()=>{
                alert('Blog Post Edited');
                setUpdateMode(false);
                navigate(`/blog/view/${articlePost.id}`);
            });   
        }catch (error) {
            console.log(error);  
        }
    }

    return (
        <>
            <ArticlePageBanner PT={articlePost?.title} img={img} />
            <section className="pt-90 pb-120 gray-bg">
                <div className="container">
                    <div className="row">
                        <div className='col-lg-8'>
                            <div className="blog-details mt-30">
                                <div className="thum">
                                    { file ? (
                                        <img src={URL.createObjectURL(file)} alt="" />
                                    ): (
                                        articlePost?.picture && <img src={img + articlePost.picture} alt="" className="img-fluid w-100" style={{height: '500px', objectFit: 'cover'}} />
                                    )}
                                </div>
                                { updateMode ? 
                                    <div className='main-form pt-45'>
                                        <form className="p-2">
                                            <div className="singel-form form-group">
                                                <label htmlFor="fileInput"><h5>Change Image: <i className="fa fa-recycle" /></h5></label>
                                                <input type="file" id="fileInput" style={{display: "none"}} onChange={(e)=>setFile(e.target.files[0])} />
                                            </div>
                                            <div className="section-title form-group">
                                                <br /><h5>Title</h5> 
                                                <input className="form-control p-2" required="required" type='text' value={title} onChange={(e)=>setTitle(e.target.value)} />
                                            </div>
                                            <div className="section-title form-group">
                                                <br /><h5>Post Content</h5>
                                                <EditorToolbar toolbarId={'t1'} />
                                                <ReactQuill theme="snow" rows="10" modules={modules('t1')} formats={formats} value={detail} onChange={onDetail} placeholder={"Tell your story ..."} />
                                            </div>
                                            <br />
                                            <button type="submit" className="main-btn" onClick={updatePost}>Update</button>
                                            &nbsp;&nbsp;&nbsp;  
                                            <button className="main-btn" onClick={(e)=>setUpdateMode(false)}>Cancel</button>
                                        </form>
                                    </div> 
                                : 
                                    <div className='cont'>
                                        <h3 className="mb-3 text-secondary text-capitalize font-weight-bold">{articlePost?.title}</h3>
                                        <ul>
                                            <li><Link to="#date"><i className="fa fa-calendar"></i>{new Date(articlePost?.createdAt).toDateString()}</Link></li>
                                            { authDecode && (authDecode?.user?.id === articlePost.userId || authDecode?.user?.role >= 4) ? (<>
                                                <li><Link to="#edit"><i className="fa fa-edit" aria-hidden="true" onClick={() => setUpdateMode(true)}/></Link>Edit</li>
                                                <li><Link to="#delete"><i className="fa fa-trash" aria-hidden="true" onClick={() => deletePost(articlePost.id)} /></Link>Delete</li>            
                                            </>):(<></>)}
                                        </ul>                  
                                        <p dangerouslySetInnerHTML={{ __html: articlePost.detail}} style={{whiteSpace: "pre-line"}} />
                                    </div>
                                }
                            </div>
                        </div>
                        <RightSideBar />  
                    </div>
                </div>
            </section>
        </>
    )
}

export default Article